<template>
    <div class="continue-banner" v-if="continueBannerVisible">
        <p class="continue-banner__body">
            Would you like to continue where you left off?
            <button @click.stop.prevent="goToLastView()">Yes</button>
            <button @click.stop.prevent="clearCookies()">No</button>
        </p>
    </div>
</template>
<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
            return {
                continuePage: '',
                continueStep: ''
            }
        },
        /////////////////////////////////////////////////////
        // Props
        /////////////////////////////////////////////////////
        props: {
            'step': {
                type: Number,
                default: 0
            },
            'dataLoaded': {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.continuePage = this.$cookie.get('continuePage')
            this.continueStep = this.$cookie.get('continueStep')
        },
        computed: {
            continueBannerVisible () {
                return this.continuePage && this.continueStep
            }
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            clearCookies() {
                this.continuePage = ''
                this.continueStep = ''
                this.$cookie.delete('continuePage')
                this.$cookie.delete('continueStep')
            },
            goToLastView () {
                window.location = this.continuePage + '#' + this.continueStep
            }
        }
    }

</script>
